import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import "./StackedBarChart.scss";
import React, { Component } from "react";

export default class StackedBarChart extends Component {
  render() {
    return (
      <div className="responsiveBarchart">
        <ResponsiveContainer>
          <BarChart
            data={this.props.data}
            barSize={14}
            margin={{ top: 0, right: 20, left: 0, bottom: 0 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" /*dy={20}*/ interval={0} top={50} />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar
              //dataKey="approved"
              dataKey={this.props.dataKeys[0]}
              stackId="a"
              fill={this.props.barchartColors[0]}
            />
            {this.props.dataKeys.length > 1 ? (
              <Bar
                dataKey={this.props.dataKeys[1]}
                stackId="a"
                fill={this.props.barchartColors[1]}
              />
            ) : (
              ""
            )}
          </BarChart>
        </ResponsiveContainer>
      </div>
    );
  }
}
